import { Component } from '@angular/core';
import { Router, RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService, readStoredBrandImageUrl, readStoredChatbotNumber, readStoredOrgName } from '../shared/auth.service';

@Component({
  standalone: true,
  selector: 'app-shell',
  imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive],
  template: `
  <div class="shell">
    <!-- Innovative menu: a slim icon-rail + expandable labels (desktop) and a bottom dock (mobile) -->
    <aside class="rail" aria-label="Primary navigation">
      <div class="brand" title="OmnifaiChat">
        <img class="brandImg" [src]="brandImageUrl" (error)="onBrandImageError($event)" alt="OmnifAI logo" />
        <div class="wordmark">
          <div class="wmTop">{{ orgName }}</div>
          <div class="wmSub">
            <span class="waIc" aria-hidden="true">
              <svg viewBox="0 0 24 24"><path d="M20.5 11.5a8.5 8.5 0 0 1-12.1 7.7L4 20l.8-4.1A8.5 8.5 0 1 1 20.5 11.5z"/><path d="M9.6 8.7c.2-.4.4-.4.6-.4h.5c.2 0 .4 0 .5.3.2.4.7 1.8.8 1.9.1.2.1.4 0 .5-.1.1-.2.3-.4.4-.1.1-.3.3-.1.6.2.3 1 1.6 2.4 2.2.2.1.4.1.5 0 .1-.1.4-.5.6-.7.2-.2.3-.2.6-.1.2.1 1.5.7 1.7.9.2.1.4.2.4.4s-.1 1.1-.8 1.5c-.7.4-1.5.5-2.2.3-.8-.2-1.6-.5-2.4-1.1-1.3-.9-2.2-2.1-2.8-3.3-.5-1.1-.1-1.8.2-2.2z"/></svg>
            </span>
            <span>WhatsApp Cloud API</span>
          </div>
          <div class="wmMeta" *ngIf="chatbotNumber">
            <span class="phoneIc" aria-hidden="true">
              <svg viewBox="0 0 24 24"><path d="M7.5 4h9a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-9a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"/><path d="M10 7h4M11.5 17h1"/></svg>
            </span>
            <span>{{ formatSidebarPhone(chatbotNumber) }}</span>
          </div>
        </div>
      </div>

      <nav class="nav">
        <a routerLink="/inbox" routerLinkActive="active" class="item">
          <span class="ic" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M4 6.5a3.5 3.5 0 0 1 3.5-3.5h9A3.5 3.5 0 0 1 20 6.5v6A3.5 3.5 0 0 1 16.5 16H10l-4.5 4v-4A3.5 3.5 0 0 1 4 12.5z"/></svg>
          </span><span class="tx">Inbox</span>
        </a>
        <a routerLink="/leads" routerLinkActive="active" class="item">
          <span class="ic" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M12 3l2.3 4.7L19 10l-4.7 2.3L12 17l-2.3-4.7L5 10l4.7-2.3z"/></svg>
          </span><span class="tx">Leads</span>
        </a>
        <a routerLink="/orders" routerLinkActive="active" class="item">
          <span class="ic" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M7 3h10v18l-2.5-1.5L12 21l-2.5-1.5L7 21z"/><path d="M9 8h6M9 11h6M9 14h4"/></svg>
          </span><span class="tx">Orders</span>
        </a>
        <a routerLink="/inventory" routerLinkActive="active" class="item">
          <span class="ic" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M3 7l9-4 9 4-9 4z"/><path d="M3 7v10l9 4 9-4V7"/><path d="M12 11v10"/></svg>
          </span><span class="tx">Inventory</span>
        </a>
        <a routerLink="/dashboard" routerLinkActive="active" class="item">
          <span class="ic" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M4 20V4M8 20V12M12 20V8M16 20V14M20 20V6"/></svg>
          </span><span class="tx">Dashboard</span>
        </a>
        <a routerLink="/profile" routerLinkActive="active" class="item">
          <span class="ic" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4zM5 20a7 7 0 0 1 14 0"/></svg>
          </span><span class="tx">Profile</span>
        </a>
      </nav>

      <div class="railFooter">
        <button class="mode" (click)="toggleTheme()" aria-label="Toggle theme">
          <span class="ic" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M12 3a9 9 0 1 0 9 9 7 7 0 1 1-9-9z"/></svg>
          </span><span class="tx">Theme</span>
        </button>
        <button class="mode logout" (click)="logout()" aria-label="Logout">
          <span class="ic" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M15 7l5 5-5 5M20 12H9"/><path d="M11 4H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h6"/></svg>
          </span><span class="tx">Logout</span>
        </button>
      </div>
    </aside>

    <div class="mainArea">
      <main class="content">
        <router-outlet></router-outlet>
      </main>
      <footer class="siteFooter" aria-label="Site footer">
        <span class="fItem">Powered by <b>OmnifAI</b></span>
        <span class="dot">•</span>
        <span class="fItem">{{ orgName }}</span>
        <span class="dot">•</span>
        <span class="fItem">v1.1</span>
        <span class="dot">•</span>
        <span class="fItem">© {{ year }}</span>
      </footer>
    </div>

    <nav class="dock" aria-label="Mobile navigation">
      <a routerLink="/inbox" routerLinkActive="active"><span class="ic"><svg viewBox="0 0 24 24"><path d="M4 6.5a3.5 3.5 0 0 1 3.5-3.5h9A3.5 3.5 0 0 1 20 6.5v6A3.5 3.5 0 0 1 16.5 16H10l-4.5 4v-4A3.5 3.5 0 0 1 4 12.5z"/></svg></span><span>Inbox</span></a>
      <a routerLink="/leads" routerLinkActive="active"><span class="ic"><svg viewBox="0 0 24 24"><path d="M12 3l2.3 4.7L19 10l-4.7 2.3L12 17l-2.3-4.7L5 10l4.7-2.3z"/></svg></span><span>Leads</span></a>
      <a routerLink="/orders" routerLinkActive="active"><span class="ic"><svg viewBox="0 0 24 24"><path d="M7 3h10v18l-2.5-1.5L12 21l-2.5-1.5L7 21z"/><path d="M9 8h6M9 11h6M9 14h4"/></svg></span><span>Orders</span></a>
      <a routerLink="/inventory" routerLinkActive="active"><span class="ic"><svg viewBox="0 0 24 24"><path d="M3 7l9-4 9 4-9 4z"/><path d="M3 7v10l9 4 9-4V7"/><path d="M12 11v10"/></svg></span><span>Stock</span></a>
      <a routerLink="/dashboard" routerLinkActive="active"><span class="ic"><svg viewBox="0 0 24 24"><path d="M4 20V4M8 20V12M12 20V8M16 20V14M20 20V6"/></svg></span><span>Dash</span></a>
      <a routerLink="/profile" routerLinkActive="active"><span class="ic"><svg viewBox="0 0 24 24"><path d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4zM5 20a7 7 0 0 1 14 0"/></svg></span><span>Me</span></a>
      <a (click)="logout()" role="button" tabindex="0"><span class="ic"><svg viewBox="0 0 24 24"><path d="M15 7l5 5-5 5M20 12H9"/><path d="M11 4H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h6"/></svg></span><span>Out</span></a>
    </nav>
  </div>
  `,
  styles: [`
    .shell{height:100vh; display:flex; background:var(--bg)}
    .rail{
      width:76px; min-width:76px;
      background:linear-gradient(180deg, rgba(17,27,33,.98), rgba(11,20,26,.95));
      border-right:1px solid var(--border);
      display:flex; flex-direction:column; align-items:stretch;
      padding:10px 8px;
    }
    :host-context(body.light) .rail{
      background:linear-gradient(180deg, rgba(255,255,255,.98), rgba(248,250,252,.98));
      border-right-color:rgba(15,23,42,.10);
    }
    .brand{display:flex; align-items:center; justify-content:center; gap:10px; padding:6px 2px 10px}
    .brandImg{width:48px;height:48px;object-fit:cover;border-radius:14px;display:block}
    .wordmark{display:none;min-width:0}
    .wmTop{font-size:13px;font-weight:900;line-height:1.05;color:var(--text)}
    .wmSub{font-size:10px;color:var(--muted);margin-top:2px;white-space:nowrap;display:flex;align-items:center;gap:5px}
    .wmMeta{font-size:10px;color:var(--muted);margin-top:3px;display:flex;align-items:center;gap:5px;white-space:nowrap}
    .waIc{width:11px;height:11px;display:inline-flex;align-items:center;justify-content:center;color:rgba(37,211,102,.95)}
    .waIc svg{width:11px;height:11px;fill:none;stroke:currentColor;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round}
    .phoneIc{width:11px;height:11px;display:inline-flex;align-items:center;justify-content:center;color:rgba(125,211,252,.95)}
    .phoneIc svg{width:11px;height:11px;fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}
    .nav{display:flex; flex-direction:column; gap:6px; margin-top:6px}
    .item, .mode{
      display:flex; align-items:center; gap:10px;
      width:100%;
      border-radius:16px;
      padding:11px 10px;
      color:var(--muted);
      border:1px solid transparent;
      background:transparent;
      cursor:pointer;
      text-decoration:none;
      transition: .16s ease;
      position:relative;
      overflow:hidden;
    }
    .item:hover, .mode:hover{background:rgba(42,57,66,.45); color:var(--text); border-color:rgba(42,57,66,.55)}
    :host-context(body.light) .item:hover,
    :host-context(body.light) .mode:hover{
      background:rgba(15,23,42,.06);
      border-color:rgba(15,23,42,.12);
    }
    .item.active{
      background:rgba(0,168,132,.12);
      border-color:rgba(0,168,132,.35);
      color:var(--text);
    }
    :host-context(body.light) .item.active{
      background:rgba(2,132,199,.12);
      border-color:rgba(2,132,199,.34);
      color:#0f172a;
    }
    /* Innovative accent “energy bar” */
    .item.active::before{
      content:'';
      position:absolute; left:0; top:8px; bottom:8px;
      width:4px; border-radius:999px;
      background:rgba(0,168,132,.95);
      box-shadow: 0 0 0 6px rgba(0,168,132,.10);
    }
    .ic{
      width:22px;height:22px;display:inline-flex;align-items:center;justify-content:center;
      color:currentColor;
    }
    .ic svg{width:18px;height:18px;fill:none;stroke:currentColor;stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round}
    .tx{display:none; font-weight:800; font-size:13px; white-space:nowrap}
    .rail:hover .tx{display:inline}
    .rail:hover .wordmark{display:block}
    .rail:hover{width:220px; min-width:220px}
    .railFooter{margin-top:auto; padding-top:10px}
    .mainArea{flex:1; min-width:0; min-height:0; display:flex; flex-direction:column; overflow:hidden}
    .content{flex:1; min-width:0; min-height:0; overflow:auto}
    .content > router-outlet + *{display:block; width:100%; min-height:100%}
    .siteFooter{
      height:30px;
      flex:0 0 30px;
      display:flex;
      align-items:center;
      justify-content:center;
      gap:8px;
      font-size:11px;
      color:var(--muted);
      border-top:1px solid var(--border);
      background:var(--panel);
      white-space:nowrap;
      overflow:auto;
      padding:0 10px;
      position:relative;
      z-index:3;
    }
    .fItem b{color:var(--text)}
    .dot{opacity:.6}
    .siteFooter::-webkit-scrollbar{height:0}
    .siteFooter{scrollbar-width:none}
    :host-context(body.light) .siteFooter{
      background:#fff;
    }

    /* Mobile: hide rail, show dock */
    .dock{display:none}
    @media (max-width: 900px){
      .rail{display:none}
      .mainArea{padding-bottom:64px}
      .dock{
        position:fixed; left:0; right:0; bottom:0; height:64px;
        display:flex;
        background:var(--panel);
        border-top:1px solid var(--border);
      }
      :host-context(body.light) .dock{
        background:rgba(255,255,255,.98);
        border-top-color:rgba(15,23,42,.10);
      }
      .dock a{
        flex:1; display:flex; flex-direction:column; align-items:center; justify-content:center;
        gap:2px; color:var(--muted); text-decoration:none;
        border-top:2px solid transparent;
        font-size:16px;
      }
      .dock .ic{width:20px;height:20px}
      .dock .ic svg{width:18px;height:18px;fill:none;stroke:currentColor;stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round}
      .dock a span{font-size:11px}
      .dock a.active{
        color:var(--text);
        border-top-color:rgba(0,168,132,.9);
        background:rgba(0,168,132,.08);
      }
      :host-context(body.light) .dock a.active{
        color:#0f172a;
        border-top-color:rgba(2,132,199,.8);
        background:rgba(2,132,199,.10);
      }
    }
  `]
})
export class AppShellComponent {
  year = new Date().getFullYear();
  get brandImageUrl(): string {
    return readStoredBrandImageUrl() || 'assets/omnifai-logo.png';
  }
  get orgName(): string {
    return readStoredOrgName();
  }
  get chatbotNumber(): string {
    return readStoredChatbotNumber();
  }

  constructor(private auth: AuthService, private router: Router) {}

  toggleTheme(){
    document.body.classList.toggle('light');
  }

  logout(): void {
    this.auth.logout();
    this.router.navigateByUrl('/login');
  }

  onBrandImageError(event: Event): void {
    const target = event.target as HTMLImageElement | null;
    if (!target) return;
    target.src = 'assets/omnifai-logo.png';
  }

  formatSidebarPhone(value: string): string {
    const raw = (value || '').trim();
    if (!raw) return '';

    let digits = raw.replace(/[^\d+]/g, '');
    if (digits.startsWith('00')) digits = `+${digits.slice(2)}`;
    if (!digits.startsWith('+')) digits = `+${digits.replace(/\D/g, '')}`;
    const onlyDigits = digits.slice(1);
    if (!onlyDigits) return raw;

    const cc = this.detectCountryCode(onlyDigits);
    const local = onlyDigits.slice(cc.length);
    if (!local) return `+${cc}`;
    if (cc === '971' && local.length === 9) {
      return `+${cc} ${local.slice(0, 2)} ${local.slice(2, 5)} ${local.slice(5)}`;
    }
    return `+${cc} ${this.groupLocalNumber(local)}`;
  }

  private detectCountryCode(digits: string): string {
    const callingCodes = new Set([
      '1', '7', '20', '27', '30', '31', '32', '33', '34', '36', '39', '40', '41', '43', '44', '45', '46', '47',
      '48', '49', '51', '52', '53', '54', '55', '56', '57', '58', '60', '61', '62', '63', '64', '65', '66', '81',
      '82', '84', '86', '90', '91', '92', '93', '94', '95', '98', '211', '212', '213', '216', '218', '220', '221',
      '222', '223', '224', '225', '226', '227', '228', '229', '230', '231', '232', '233', '234', '235', '236',
      '237', '238', '239', '240', '241', '242', '243', '244', '245', '246', '248', '249', '250', '251', '252',
      '253', '254', '255', '256', '257', '258', '260', '261', '262', '263', '264', '265', '266', '267', '268',
      '269', '290', '291', '297', '298', '299', '350', '351', '352', '353', '354', '355', '356', '357', '358',
      '359', '370', '371', '372', '373', '374', '375', '376', '377', '378', '380', '381', '382', '383', '385',
      '386', '387', '389', '420', '421', '423', '500', '501', '502', '503', '504', '505', '506', '507', '508',
      '509', '590', '591', '592', '593', '594', '595', '596', '597', '598', '599', '670', '672', '673', '674',
      '675', '676', '677', '678', '679', '680', '681', '682', '683', '685', '686', '687', '688', '689', '690',
      '691', '692', '850', '852', '853', '855', '856', '880', '886', '960', '961', '962', '963', '964', '965',
      '966', '967', '968', '970', '971', '972', '973', '974', '975', '976', '977', '992', '993', '994', '995',
      '996', '998'
    ]);

    for (let len = 3; len >= 1; len -= 1) {
      const candidate = digits.slice(0, len);
      if (callingCodes.has(candidate)) return candidate;
    }
    return digits.slice(0, Math.min(3, digits.length));
  }

  private groupLocalNumber(local: string): string {
    if (local.length <= 4) return local;
    if (local.length === 5) return `${local.slice(0, 2)} ${local.slice(2)}`;
    if (local.length === 6) return `${local.slice(0, 3)} ${local.slice(3)}`;
    if (local.length === 7) return `${local.slice(0, 3)} ${local.slice(3)}`;
    if (local.length === 8) return `${local.slice(0, 4)} ${local.slice(4)}`;
    if (local.length === 9) return `${local.slice(0, 3)} ${local.slice(3, 6)} ${local.slice(6)}`;
    if (local.length === 10) return `${local.slice(0, 5)} ${local.slice(5)}`;
    return `${local.slice(0, 3)} ${local.slice(3, 6)} ${local.slice(6)}`;
  }
}
